const getGradingSystem = (journalGradingSystemStore, hundredPGradingSystem) =>
    journalGradingSystemStore
    ? Number(journalGradingSystemStore)
    : (hundredPGradingSystem == 1 ? 100 : 5)

export default getGradingSystem;